import { render, staticRenderFns } from "./HeaderNav.vue?vue&type=template&id=36b8511a&scoped=true"
import script from "./HeaderNav.vue?vue&type=script&lang=js"
export * from "./HeaderNav.vue?vue&type=script&lang=js"
import style0 from "./HeaderNav.vue?vue&type=style&index=0&id=36b8511a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b8511a",
  null
  
)

export default component.exports